/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Emails/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import Content from './Content/index'
import Email from './Email/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Emails({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Contact/Content/Emails"
  
}) {
let contactEmailsValueData = fromData.useDataValue({ viewPath,
context: 'contact',
path: 'emails',
})
let constantData = 1
let aggregateData = fromAggregate.lengthEquals(contactEmailsValueData, constantData)
let contactEmailsValueData1 = fromData.useDataValue({ viewPath,
context: 'contact',
path: 'emails',
})
let constantData1 = 1
let aggregateData1 = fromAggregate.lengthEquals(contactEmailsValueData1, constantData1)
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 offsetMainAxis={4}
 data="contact.emails"
 data={1}
 aggregate="/Data/aggregate.js lengthEquals"
 disabled={aggregateData}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
 cursor={aggregateData1 ? "default" : "pointer"}
 data="contact.emails"
 data={1}
 aggregate="/Data/aggregate.js lengthEquals"
>
{childProps => (
<Email
{...childProps}
  viewPath={`${viewPath}/Email`}
/>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
 width="auto"
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}